import { callUtag, flushUtagQueue } from "./utagCaller";

function initTealiumTracker() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      schema = _ref.schema,
      _ref$debugMode = _ref.debugMode,
      debugMode = _ref$debugMode === void 0 ? false : _ref$debugMode;

  document.addEventListener("utag-loaded", function () {
    if (debugMode) {
      console.log("utag loaded");
    }

    flushUtagQueue({
      debugMode: debugMode
    });
  });
  var validate;

  if (schema) {
    var Ajv = require("ajv");

    var ajv = new Ajv({
      allErrors: true
    });
    validate = ajv.compile(schema);
  }

  function validateDataLayer(dataLayer, errorMessage) {
    if (!validate || validate(dataLayer)) {
      return true;
    }

    console.error("".concat(errorMessage, " with"), JSON.stringify(dataLayer, null, 2), "because data validation failed:", JSON.stringify(validate.errors, null, 2));
    return false;
  }

  function trackPageLoad(dataLayer) {
    if (validateDataLayer(dataLayer, "didn't call utag.view")) {
      callUtag("view", dataLayer, {
        validateDataLayer: validateDataLayer,
        debugMode: debugMode
      });
    }
  }

  function trackEvent(dataLayer) {
    if (validateDataLayer(dataLayer, "didn't call utag.link")) {
      callUtag("link", dataLayer, {
        validateDataLayer: validateDataLayer,
        debugMode: debugMode
      });
    }
  }

  return {
    trackPageLoad: trackPageLoad,
    trackEvent: trackEvent
  };
}

export default initTealiumTracker;